import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("AuthErrorTO")
export class AuthErrorTO {

  info: string;

  type: string;
}
